var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTestId, Lottie } from '@airtel/air-design-system';
import { useState } from 'react';
import { Pressable, View } from 'react-native';
import { getWithLottieStyles } from './WithLottieStyles';
export var withLottie = Component => {
  var Wrapper = props => {
    var showLottie = props.showLottie,
      _props$lottieProps = props.lottieProps,
      lottieProps = _props$lottieProps === void 0 ? {} : _props$lottieProps,
      restProps = __rest(props, ["showLottie", "lottieProps"]);
    var id = lottieProps.id,
      showAsFullPage = lottieProps.showAsFullPage,
      onAnimationFinishMetaData = lottieProps.onAnimationFinishMetaData,
      onAnimationFailureMetaData = lottieProps.onAnimationFailureMetaData,
      containerStyle = lottieProps.containerStyle,
      style = lottieProps.style,
      _lottieProps$isPressa = lottieProps.isPressable,
      isPressable = _lottieProps$isPressa === void 0 ? false : _lottieProps$isPressa;
    var onPressMetaData = lottieProps.onPressMetaData;
    var withLottieStyles = getWithLottieStyles();
    var _useState = useState({}),
      lottieContainerStyle = _useState[0],
      setLottieContainerStyle = _useState[1];
    var LottieWrapper = isPressable ? Pressable : View;
    if (showLottie) {
      return _jsxs(LottieWrapper, Object.assign({
        style: [withLottieStyles.container, lottieContainerStyle, containerStyle],
        onPress: isPressable ? () => {
          var _a;
          onPressMetaData && ((_a = props.onUserAction) === null || _a === void 0 ? void 0 : _a.call(props, Object.assign({
            id
          }, onPressMetaData), {
            lottieProps
          }));
        } : undefined
      }, getTestId(props.testID, 'withLottie'), {
        children: [_jsx(Lottie, Object.assign({}, lottieProps, {
          onAnimationFinish: () => {
            var _a;
            onAnimationFinishMetaData && ((_a = props.onUserAction) === null || _a === void 0 ? void 0 : _a.call(props, Object.assign({
              id
            }, onAnimationFinishMetaData)));
          },
          onAnimationFailure: () => {
            var _a;
            onAnimationFailureMetaData && ((_a = props.onUserAction) === null || _a === void 0 ? void 0 : _a.call(props, Object.assign({
              id
            }, onAnimationFailureMetaData)));
          },
          style: [!showAsFullPage && withLottieStyles.lottie, style]
        })), _jsx(Component, Object.assign({
          onLayout: event => {
            var _a, _b, _c, _d;
            setLottieContainerStyle({
              width: (_b = (_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.width,
              height: (_d = (_c = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _c === void 0 ? void 0 : _c.layout) === null || _d === void 0 ? void 0 : _d.height
            });
          }
        }, restProps))]
      }));
    }
    return _jsx(Component, Object.assign({}, restProps));
  };
  return Wrapper;
};